import { LanguageDirection } from '../entities';
import { getCurrentLanguage } from '../utils/getCurrentLanguage';
import { getLanguageDirection } from '../utils/getLanguageDirection';

export function useLanguage() {
  const language = getCurrentLanguage();
  const dir = getLanguageDirection(language);
  const isRtl = dir === LanguageDirection.RTL;

  return {
    language,
    isRtl,
    dir,
  };
}
